import React from 'react';

const Error = ({msg}) => {
	return ( 
		<p className="my-3 p-4 text-center alert alert-primary">{msg}</p>
	 );
}

export default Error;